import { render, staticRenderFns } from "./DealerLocator.vue?vue&type=template&id=96300984&scoped=true"
import script from "./DealerLocator.vue?vue&type=script&lang=ts"
export * from "./DealerLocator.vue?vue&type=script&lang=ts"
import style0 from "./DealerLocator.vue?vue&type=style&index=0&id=96300984&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "96300984",
  null
  
)

export default component.exports